import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft, Play } from 'lucide-react';
import { SmartImage } from '@/shared/ui/SmartImage';
import { getMovieById } from '@/shared/data';

export function Watch() {
  const { id = '' } = useParams<{ id: string }>();
  const movie = getMovieById(id);
  if (!movie) return <Navigate to="/movieflix" replace />;
  return (
    <div data-testid="watch-page" data-movie-id={movie.id} className="-mt-16 -mb-28 h-screen relative bg-black">
      <SmartImage fill src={movie.backdrop} alt={movie.title} sizes="100vw" className="opacity-30 h-full" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <div className="w-20 h-20 rounded-full glass-strong flex items-center justify-center mb-6">
          <Play className="w-8 h-8 text-white fill-current" />
        </div>
        <div className="text-[10px] uppercase tracking-widest text-amber-200/80">Now Playing (Preview)</div>
        <h1 className="font-serif italic text-3xl text-white mt-2">{movie.title}</h1>
        <div className="text-white/40 text-xs mt-6">Player coming soon · Tap below to go back</div>
        <Link
          to={`/movieflix/movie/${movie.id}`}
          className="mt-8 inline-flex items-center gap-2 px-5 py-2 rounded-full glass text-sm text-white/80"
        >
          <ArrowLeft className="w-4 h-4" /> Back to details
        </Link>
      </div>
    </div>
  );
}
